// 网鱼 优惠券
import React, { useEffect, useRef } from 'react';
import { Button, Form, Radio } from 'antd';
import intl from 'react-intl-universal';

import { SourceChannelType } from '@/config/constant';
import { Icoupon } from '@/redux/reducers/guest';
import CouponItem from '@/components/SelectDiscountCoupon/component/CouponItem';
import noCouponUrl from '@/components/SelectDiscountCoupon/component/img/no_coupon.png';
import styles from '@/components/SelectDiscountCoupon/index.module.scss';
import PresentedCouponDrawer, { imperativeHandle } from '@/components/PresentedCouponDrawer';

export interface ICouponItem extends Icoupon {
  isChecked: boolean;
  isDisabled: boolean;
}

interface IProps {
  channelType: SourceChannelType;
  couponList: ICouponItem[];
  guestInfo: any;
  handleSelect: (couponNo: string) => void;
  refreshList: () => void;
  onSortTypeChange: (type: 1 | 2) => void;
}

const Index: React.FC<IProps> = (props) => {
  const giveAwayRef = useRef<imperativeHandle>();
  const { couponList, channelType, guestInfo, handleSelect, refreshList, onSortTypeChange } = props;
  const couponSelectAble = channelType === SourceChannelType.WALK_IN; // 网鱼券是否可用

  const handleSortTypeChange = (event) => {
    onSortTypeChange(event.target.value);
  };

  const handleOpenGiveCouponDrawer = () => {
    giveAwayRef.current.openDrawer({
      record: guestInfo,
      onOk: () => {
        refreshList();
      },
    });
  };

  // 排序类型
  const renderSortType = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: couponList.length ? 'space-between' : 'flex-end',
          marginBottom: '16px',
        }}
      >
        {couponList?.length ? (
          <Form.Item label={intl.get('reservation_cmp_coupon_selector_sort_label')}>
            <Radio.Group defaultValue={1} onChange={handleSortTypeChange}>
              <Radio.Button value={1}>
                {intl.get('reservation_cmp_coupon_selector_sort_option_time')}
              </Radio.Button>
              <Radio.Button value={2}>
                {intl.get('reservation_cmp_coupon_selector_sort_option_amount')}
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
        ) : null}
        <div>
          <Button type="primary" ghost style={{ marginRight: '16px' }}>
            {intl.get('reservation_cmp_coupon_selector_exchange_btn')}
          </Button>
          <Button type="primary" ghost onClick={() => handleOpenGiveCouponDrawer()}>
            {intl.get('reservation_cmp_coupon_selector_give_btn')}
          </Button>
        </div>
      </div>
    );
  };

  const renderTipContent = () => {
    if (couponSelectAble) {
      return (
        <div style={{ marginBottom: '16px' }}>
          {intl.getHTML('reservation_cmp_coupon_selector_notice', {
            total: couponList.filter((item) => !item.isDisabled).length,
            checked: couponList.filter((item) => item.isChecked).length,
            style: styles.number,
          })}
        </div>
      );
    }
    return (
      <div style={{ margin: '0 0 16px' }}>
        {intl.get('reservation_cmp_coupon_selector_disabled')}
      </div>
    );
  };

  useEffect(() => {
    onSortTypeChange(1);
  }, []);

  return (
    <div>
      {renderSortType()}
      {renderTipContent()}
      {couponList.length ? (
        <div className={styles.couponList}>
          {couponList.map((item) => (
            <CouponItem
              key={item.couponNo}
              isCanSelect={couponSelectAble}
              coupon={item}
              checked={item.isChecked}
              disabled={item.isDisabled}
              onClick={handleSelect}
            />
          ))}
        </div>
      ) : (
        <div className={styles.noData}>
          <img src={noCouponUrl} alt={intl.get('reservation_cmp_coupon_selector_count_null')} />
          <div>{intl.get('reservation_cmp_coupon_selector_count_null')}</div>
        </div>
      )}
      <PresentedCouponDrawer ref={giveAwayRef} />
    </div>
  );
};

export default Index;
